const o = [
  "#FEEE95",
  "#F9DBAF",
  "#FFD6AE",
  "#FECDD6",
  "#FCE7F6",
  "#F6D0FE",
  "#D9D6FE",
  "#DDD6FE",
  "#C7D7FE",
  "#B2CCFF",
  "#B2DDFF",
  "#B9E6FE",
  "#A5F0FC",
  "#99F6E0",
  "#D0F8AB"
], E = (F) => {
  if (F == null)
    return "#f2f4f7";
  let D = 0;
  if (F = F.trim().toLowerCase(), F.length === 0)
    return "#f2f4f7";
  for (let e = 0; e < F.length; e++)
    D = F.charCodeAt(e) + ((D << 5) - D), D = D & D;
  return o[Math.abs(D) % o.length];
};
export {
  E as getColorFromString
};
